import { render, staticRenderFns } from "./view-posts.vue?vue&type=template&id=67a50541&"
import script from "./view-posts.vue?vue&type=script&lang=js&"
export * from "./view-posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports